/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type IssueChatMessageImageUploadUrlInput = {
  fileExtension: string;
};

export type IssueChatMessageImageUploadUrlMutationVariables = Exact<{
  input: Types.IssueChatMessageImageUploadUrlInput;
}>;


export type IssueChatMessageImageUploadUrlMutation = { issueChatMessageImageUploadUrl: { uploadUrl: string, fileName: string } };


export const IssueChatMessageImageUploadUrlDocument = gql`
    mutation issueChatMessageImageUploadUrl($input: IssueChatMessageImageUploadUrlInput!) {
  issueChatMessageImageUploadUrl(input: $input) {
    uploadUrl
    fileName
  }
}
    `;

/**
 * __useIssueChatMessageImageUploadUrlMutation__
 *
 * To run a mutation, you first call `useIssueChatMessageImageUploadUrlMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIssueChatMessageImageUploadUrlMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIssueChatMessageImageUploadUrlMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useIssueChatMessageImageUploadUrlMutation(options: VueApolloComposable.UseMutationOptions<IssueChatMessageImageUploadUrlMutation, IssueChatMessageImageUploadUrlMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IssueChatMessageImageUploadUrlMutation, IssueChatMessageImageUploadUrlMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IssueChatMessageImageUploadUrlMutation, IssueChatMessageImageUploadUrlMutationVariables>(IssueChatMessageImageUploadUrlDocument, options);
}
export type IssueChatMessageImageUploadUrlMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IssueChatMessageImageUploadUrlMutation, IssueChatMessageImageUploadUrlMutationVariables>;